import { useMediaQuery } from '@mantine/hooks';

/**
 * The one breakpoint: Mantine `sm` (48em / 768px), the same one AppShell collapses the
 * navbar at. There is deliberately no second cutoff.
 *
 * `getInitialValueInEffect: false` so the first paint already knows the width. The default
 * reports desktop on the first render and corrects itself in an effect, which makes a phone
 * flash the desktop table before swapping to the card list.
 */
export const useIsMobile = (): boolean =>
    useMediaQuery('(max-width: 48em)', false, { getInitialValueInEffect: false }) ?? false;
